import React from "react";
// import HttpServices from "../../utils/Http.services";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import moment from "jalali-moment";
import { Bar, Bubble, Doughnut, HorizontalBar, Line, Pie, Polar, Radar, Scatter } from "react-chartjs-2";
import { getBoundingClientRect } from "../utils/functions";

import CircleBar from "../components/CircleBar";
import HttpServices from "../utils/Http.services";

class Report extends React.Component {
    state = {
        countries: [],
        box: [
            { title: 'کل عدم انطباق', number: 0, status: "0.7%+", color: "#eb3c2a", icon: '/images/icons/icons8-triangle-26-green.png', left: '-65px' },
            { title: 'عدم انطباق های خاتمه بافته', number: 0, status: "0.8%+", color: "#eb3c2a", icon: '/images/icons/icons8-triangle-26-green.png', left: '-65px', key: 'Done' },
            { title: 'عدم انطباق های رد شده', number: 0, status: "0.1%-", color: "#29c835", icon: '/images/icons/icons8-triangle-26-red.png', left: '-65px', key: 'reject' },
            { title: 'عدم انطباق (بازرسی اولیه)', number: 0, status: "0.1%-", color: "#29c835", icon: '/images/icons/icons8-triangle-26-red.png', left: '-65px', key: 'initialReview' },
            { title: 'عدم انطباق (اصلاحی)', number: 0, status: "0.1%-", color: "#29c835", icon: '/images/icons/icons8-triangle-26-red.png', left: '-65px', key: 'correction' },
            { title: 'عدم انطباق (ریشه یابی)', number: 0, status: "0.1%-", color: "#29c835", icon: '/images/icons/icons8-triangle-26-red.png', left: '-65px', key: 'userRootting' },
            { title: 'عدم انطباق (برنامه ریزی)', number: 0, status: "0.1%-", color: "#29c835", icon: '/images/icons/icons8-triangle-26-red.png', left: '-65px', key: 'userPlanning' },
            { title: 'عدم انطباق (ثبت نتیجه)', number: 0, status: "0.1%-", color: "#29c835", icon: '/images/icons/icons8-triangle-26-red.png', left: '-65px', key: 'recordResult' },
            { title: 'عدم انطباق (نتیحه گیری)', number: 0, status: "0.1%-", color: "#29c835", icon: '/images/icons/icons8-triangle-26-red.png', left: '-65px', key: 'conclusion' },
            { title: 'عدم انطباق (اثزبخشی)', number: 0, status: "0.1%-", color: "#29c835", icon: '/images/icons/icons8-triangle-26-red.png', left: '-65px', key: 'userEffectiveness' },
        ],
        sections: [],
        headers: this.props.page?.headers,
        actions: {
        },
        pie: {
            labels: [],
            datasets: [
                {
                    data: [10, 20, 21],
                    backgroundColor: ['#FFD32D', '#008E89', '#084594'],
                },
            ],
        },

        data: {
            nonComplianceDoughnut: {
                labels: ['عدم انطباق های خاتمه بافته', 'عدم انطباق های رد شده', 'عدم انطباق (بازرسی اولیه)', 'عدم انطباق (اصلاحی)', 'عدم انطباق (ریشه یابی)', 'عدم انطباق (برنامه ریزی)', 'عدم انطباق (ثبت نتیجه)', 'عدم انطباق (نتیحه گیری)', 'عدم انطباق (اثزبخشی)'],
                datasets: [
                    {
                        data: [],
                        backgroundColor: ['#FFD32D', '#008E89', '#084594', '#d627a2', '#14c43a', '#f883fc', '#b0043d', '#84f06e', '#650f94'],
                        barThickness: 20,
                    },
                ],

            },
            processes: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: ['#FFD32D', '#008E89', '#084594', '#d627a2', '#14c43a', '#f883fc', '#b0043d', '#84f06e', '#650f94'],
                        barThickness: 20,
                    },
                ],

            },
            orgStandard: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: ['#FFD32D', '#008E89', '#084594', '#d627a2', '#14c43a', '#f883fc', '#b0043d', '#84f06e', '#650f94'],
                        barThickness: 20,
                    },
                ],

            },
            bar: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: ['#FFD32D', '#008E89', '#084594', '#d627a2', '#14c43a', '#f883fc', '#b0043d', '#84f06e', '#650f94'],
                        barThickness: 20,
                    },
                ],

                options: {
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    min: 0,
                                    max: 50,
                                },
                            },
                        ],
                    },
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem) {
                                return tooltipItem.yLabel;
                            }
                        }
                    }
                },
            },
            line: {
                labels: [],
                datasets: [
                    {
                        label: 'Temperature',
                        data: [1, 2, 4, 1, 2, 4],
                        fill: false,
                        backgroundColor: 'rgb(237, 196, 86)',
                        borderColor: 'rgba(237, 196, 86)',
                        barThickness: 20,
                    },
                ],
                options: {
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    min: 0,
                                    max: 50,
                                },
                            },
                        ],
                    },
                },
            },

        },



        // 
        dataBox: {
            labels: [],
            datasets: [
                {
                    data: [10, 20, 30, 40, 50],
                    backgroundColor: ['#FFD32D', '#008E89', '#084594', '#FF6492', '#5B5B5B'],
                    borderWidth: 0,
                },
            ],
        },
        optionsBox: {
            plugins: {
                legend: {
                    display: false, // Hide legend
                },
            },
            scales: {
                x: {
                    display: false, // Hide x-axis
                },
                y: {
                    display: false, // Hide y-axis
                },
            },
            responsive: true,
            maintainAspectRatio: false,
        },

        timeChartOptions: {
            bezierCurve: false,
            zoom: {
                enabled: true,
                // drag:true,
                mode: 'xy',
                overScaleMode: 'y',
                modifierKey: 'shift',

                wheel: {
                    enabled: false,
                    modifierKey: 'shift',

                },


                drag: {
                    enabled: true,
                    modifierKey: 'shift',

                },

                pinch: {
                    enabled: true,
                    modifierKey: 'shift',

                },


            },




            scales: {
                xAxes: [

                    {
                        gridLines: {
                            color: 'transparent',


                        },
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#afafaf',
                            fontSize: 12,
                        }
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            color: "#eeeeeeFF"

                        },
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#afafaf',
                            fontSize: 12,
                        }
                    },
                ],


            }
        },
    }
    componentDidMount() {
        this.init()
        this.setState({ sections: this.props.page?.sections, headers: this.props.page?.headers })
        // console.log('this.props.page.sections', this.props.page.sections)
        // console.log('window.location', window.location)
        window.addEventListener('resize', this.getSize)
        this.getSize()

        // console.log('admin', this.props.page.headers)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.headers != this.props.headers) {
            this.init()
        }
    }

    init() {
        let page = this.props.page
        let address = page.fetchUrl
        console.log('asdsad', address)
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let id = params.get('id');
        console.log('id is', id)
        let body = {}
        body.id = id
        HttpServices.request(address, body, (fetchResult, fetchError) => {
            console.log(fetchError)
            console.log('fetchResult', fetchResult)
            // this.groupBy(fetchResult.info)
            // this.setState({ data: fetchResult?.info, id: id })
        })
        this.setState({ headers: this.props.headers, activePage: null })
    }
    groupBy = (info) => {
        let tempObj = { users: [], stage: {}, noComplianceUsers: {}, processes: {}, orgStandard: {} }
        info.nonCompliance.map((element) => {
            element.inChargeUsers.map((prop) => {
                let found
                let tIndex
                tempObj.users.map((item, uIndex) => {
                    if (item.id == prop.id) {
                        found = true
                        tIndex = uIndex
                    }
                })
                if (!found) {
                    tempObj.users.push({ ...prop, number: 1 })
                }
                else {
                    tempObj.users[tIndex].number += 1
                }

            });
            if (!tempObj.stage[element.stage]) {
                tempObj.stage[element.stage] = []
            }
            tempObj.stage[element.stage].push(element)

            info.processes.map((item) => {
                if (!tempObj.processes[item._id]) {
                    tempObj.processes[item._id] = { name: item.title, list: [] }
                }
                if (item._id == element.processes) {
                    tempObj.processes[item._id].list.push(element)
                }
            })
            info.orgStandard.map((item) => {
                if (!tempObj.orgStandard[item._id]) {
                    tempObj.orgStandard[item._id] = { name: item.title, list: [] }
                }
                if (item._id == element.orgStandard) {
                    tempObj.orgStandard[item._id].list.push(element)
                }
            })
        })

        console.log('list', info)
        console.log('tempObj', tempObj)
        this.setReportData(info, tempObj)

    }
    setReportData = (info, tempObj) => {
        let data = this.state.data
        let box = this.state.box
        data.bar.labels = []
        data.bar.datasets[0].data = []
        data.bar.options.scales.yAxes[0].ticks.max = info.nonCompliance.length
        tempObj.users.map((element) => {
            data.bar.labels.push(element.name)
            data.bar.datasets[0].data.push(element.number)
        })
        if (data.bar.datasets[0].backgroundColor.length < data.bar.datasets[0].data.length) {
            let diff = data.bar.datasets[0].data.length - data.bar.datasets[0].backgroundColor.length
            for (let i = 0; i < diff; i++) {
                let maxVal = 0xFFFFFF;
                let randomColor = Math.floor(Math.random() * maxVal).toString(16);
                data.bar.datasets[0].backgroundColor.push('#' + randomColor)
            }
        }
        data.nonComplianceDoughnut.datasets[0].data = []
        box.map((element, index) => {
            if (element.key) {
                box[index].number = tempObj.stage[element.key] ? tempObj.stage[element.key].length : 0
                data.nonComplianceDoughnut.datasets[0].data.push(box[index].number)
            }
            else {
                box[index].number = info.nonCompliance.length
                // data.nonComplianceDoughnut.datasets[0].data.push(list.length)
            }
        })
        //process
        data.processes.labels = []
        Object.values(tempObj.processes).map((element) => {
            data.processes.labels.push(element.name)
            data.processes.datasets[0].data.push(element.list.length)
        })
        if (data.processes.datasets[0].backgroundColor.length < data.processes.datasets[0].data.length) {
            let diff = data.processes.datasets[0].data.length - data.processes.datasets[0].backgroundColor.length
            for (let i = 0; i < diff; i++) {
                let maxVal = 0xFFFFFF;
                let randomColor = Math.floor(Math.random() * maxVal).toString(16);
                data.processes.datasets[0].backgroundColor.push('#' + randomColor)
            }
        }

        //orgStandard
        data.orgStandard.labels = []
        Object.values(tempObj.orgStandard).map((element) => {
            data.orgStandard.labels.push(element.name)
            data.orgStandard.datasets[0].data.push(element.list.length)
        })
        if (data.orgStandard.datasets[0].backgroundColor.length < data.orgStandard.datasets[0].data.length) {
            let diff = data.orgStandard.datasets[0].data.length - data.orgStandard.datasets[0].backgroundColor.length
            for (let i = 0; i < diff; i++) {
                let maxVal = 0xFFFFFF;
                let randomColor = Math.floor(Math.random() * maxVal).toString(16);
                data.orgStandard.datasets[0].backgroundColor.push('#' + randomColor)
            }
        }
        // console.log('data.nonComplianceDoughnut', data.nonComplianceDoughnut)

        this.setState({ data, box })
    }



    submitForm = () => {
        if (this.props.submitForm) {
            let data = this.form.getForm()
            if (data) {
                this.props.submitForm({ ...data })
            }
        } else {
            this.postValue()
        }
    }






    postValue = () => {
        console.log("postValue", this.state.id)
        console.log("page", this.props.page)
        if (this.form) {
            console.log('s', this.form)
            let data = this.form.getForm()
            this.setState({ errors: null })
            let page = this.props.page

            console.log('potvalue', data)
            if (data) {
                let isEditing = data._id ? true : false
                let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
                data.page = this.props.page?.page ? this.props.page?.page : this.props.page?.key
                this.setState({ isPostingData: true })

                if (page.postBody) {
                    data = { ...data, ...page.postBody }
                }

                for (const [key, value] of Object.entries(data)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {

                        if (this.props.variables) {
                            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                }
                data.id = this.state.id
                HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false })
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                        return
                    }
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}Sent Succesfully', description: '{{lang}}Send Record Succesfully' })
                    this.cancelClicked()

                })
            }
        }
    }

    cancelClicked = () => {

        this.props.history.goBack()


    }

    changePage = (index, prop) => {
        this.setState({ activePage: index, hideModal: true }, () => {
            if (index == null) {
                this.setState({ hideModal: false, headers: this.props.headers })
            } else {
                this.setState({ hideModal: false, headers: this.props.page?.pages[index].headers })

            }
        })
    }

    itemAdded = () => { }

    itemEdited = () => { }



    componentWillUnmount() {
        window.removeEventListener('resize', this.getSize)
    }

    getSize = () => {
        if (this.chartContainer) {
            let bound = getBoundingClientRect(this.chartContainer)

            this.setState({ show: false, height: bound.height, width: bound.width }, () => {
                this.setState({ show: true })
            })
        }
    }

    render() {
        const containerStyle = {
            position: 'relative',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            backgroundColor: 'lightgray',
            overflow: 'hidden',
        };

        const progressBarStyle = {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            backgroundColor: 'blue',
            transform: `rotate(${(this.state.percent / 100) * 360}deg)`,
            transition: 'transform 0.6s ease-out',
        };

        const labelStyle = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '24px',
            fontWeight: 'bold',
        };
        return (

            <div className="w-100 h-100" style={{}}>

                <div className="py-2" style={{ width: '80%', margin: '0 auto' }}>

                    <div className="row m-0 mt-3">

                        {this.state.box.map((item, index) => {
                            return (
                                <div className=" my-2 col-12 col-sm-6 col-md-6 col-lg-4 p-md-0" style={{}}>
                                    <div className="mx-md-3 flexcb p-3 h-100" style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: 15, }}>

                                        <div>
                                            <p className="" style={{ fontSize: 20, fontWeight: '400' }}>{item.number}</p>
                                            <p className="" style={{ fontSize: 12, fontWeight: '400', color: "gray", }}>{item.title}</p>
                                        </div>
                                        {index != 0 && (
                                            <div className="flexcc mt-3">
                                                <CircleBar percent={75} />

                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="row m-0" style={{}}>
                        <div className="col-12 col-md-6 my-3 " >
                            <div className="h-100" style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: 15 }}>


                                <div style={{ borderBottom: '1px solid #eee' }}>
                                    <div className="py-3 flexcc" >
                                        <p style={{ fontSize: 14 }}>
                                            وضعیت عدم انطباق ها
                                        </p>
                                    </div>
                                </div>
                                <div className="p-2" style={{ borderRadius: 15 }}>
                                    <Pie data={this.state.data.nonComplianceDoughnut} height={this.props.height} />
                                </div>
                            </div>

                        </div>
                        {/* <div className="col-12 col-md-6 " >
                            <div className="p-2" style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: 15 }}>
                                <Line
                                    data={this.state.data.line}
                                    height={this.props.height}
                                    ref={el => this.chart = el}
                                />
                            </div>
                        </div> */}

                        <div className="col-12 col-md-6 my-3 " >
                            <div className="h-100" style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: 15 }}>
                                <div style={{ borderBottom: '1px solid #eee' }}>
                                    <div className="py-3 flexcc" >
                                        <p style={{ fontSize: 14 }}>
                                            میزان عدم انطباق ها به فرآیند ها
                                        </p>
                                    </div>
                                </div>
                                <div className="py-3">
                                    <Doughnut data={this.state.data.processes} height={this.props.height} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 my-3">
                            <div className=" h-100" style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: 15 }}>
                                <div style={{ borderBottom: '1px solid #eee' }}>
                                    <div className="py-3 flexcc" >
                                        <p style={{ fontSize: 14 }}>
                                            میزان عدم انطباق هر فرد
                                        </p>
                                    </div>
                                </div>
                                <div style={{}}>
                                    <Bar data={this.state.data.bar} height={this.props.height} options={this.state.data.bar.options} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 my-3" >
                            <div className="h-100" style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: 15 }}>
                                <div style={{ borderBottom: '1px solid #eee' }}>
                                    <div className="py-3 flexcc" >
                                        <p style={{ fontSize: 14 }}>
                                            میزان عدم انطباق ها به منشا استاندارد
                                        </p>
                                    </div>
                                </div>
                                <div className="py-3">
                                    <Doughnut data={this.state.data.orgStandard} height={this.props.height} />
                                </div>
                            </div>
                        </div>


                        {/* <div className="col-12 col-md-6 my-4">
                            <div className="p-2" style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: 15 }}>
                                <HorizontalBar data={this.state.data.hBar} height={this.props.height} />
                            </div>
                        </div> */}


                    </div>
                    <div className="pb-5 h-100">

                        {this.props.showDates && this.props?.initData?._id && (
                            <div className="flexc  px-2">
                                <p className="text-small" style={{ color: '#00000050' }}>Create Date: {moment(this.props.initData?.cDate).format('YYYY MMMM DD')}</p>
                                <p className="text-small mld-4" style={{ color: '#00000050' }}>Udpate Date: {moment(this.props.initData?.uDate).format('YYYY MMMM DD')}</p>
                            </div>
                        )}
                        <p className="text-small mb-2  px-2" style={{ color: '#00000050' }}>{this.props.initData?._id}</p>
                    </div>
                </div>
            </div >
        );

    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(Report);
